import { render, staticRenderFns } from "./avatarRequire.vue?vue&type=template&id=1815f358&scoped=true"
var script = {}
import style0 from "./avatarRequire.vue?vue&type=style&index=0&id=1815f358&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1815f358",
  null
  
)

export default component.exports